import { useEffect, useState } from 'react'
import { Product, useProduct } from '../../../../hooks/useProduct'
import { Alias } from '../../../../redux/types/products'
import { PRODUCT_NOT_FOUND_ERROR, ALIAS_MISMATCH_ERROR } from './errors'

const findAlias = (product: Product | null, aliasId: string | null): Alias | null => {
  if (aliasId === null || product === null) return null

  const id = parseInt(aliasId)
  if (isNaN(id)) return null

  return product.aliases.find((alias) => alias.id === id) ?? null
}

export const useFromProduct = (productId: string | number | null, aliasId: string | null) => {
  const { product, error: productError, isLoading } = useProduct(productId)
  const [errorCode, setErrorCode] = useState<string | undefined>()
  const [productAlias, setProductAlias] = useState<Alias | null>(null)
  const [error, setError] = useState<any>()

  useEffect(() => {
    setErrorCode(undefined)
    setProductAlias(null)

    if (productError?.response?.status === 404) {
      setErrorCode(PRODUCT_NOT_FOUND_ERROR)
      setError(productError)
      return
    }

    if (product && aliasId) {
      const found = findAlias(product, aliasId)

      if (!found) {
        setErrorCode(ALIAS_MISMATCH_ERROR)
        setError(productError)
        return
      }

      setProductAlias(found)
    }
  }, [productError, product, aliasId])

  return {
    product,
    isLoading,
    error,
    errorCode,
    alias: productAlias,
  }
}
